import React, { useEffect, useRef, useState } from "react";
import { ICreateSalesData } from "../../../../@types";
import CanDollarIcon from "../../../../assets/icons/CanDollarIcon";
import NairaCurrency from "../../../../assets/icons/NairaCurrency";
import PoundsIcon from "../../../../assets/icons/PoundsIcon";
import { Tooltip } from "../../../../assets/icons/Tooltip";
import UsaIcon from "../../../../assets/icons/UsaIcon";
import { InvoiceErrors } from "../../../../modules/validateInvoiceForm";
import { DropdownComponent, InputComponent } from "../../../core/Forms";
import { useTranslation } from "react-i18next";
import ExchangeRateIcon from "../../../../assets/icons/ExchangeRateIcon";

interface InvoiceCurrencyProps {
  handleDropDownChange: (name: string, value: string) => void;
  formData: ICreateSalesData;
  setFormData: React.Dispatch<React.SetStateAction<ICreateSalesData>>;
  selectedCurrencyLabel: string;
  validationResults: InvoiceErrors;
  setValidationResults?: React.Dispatch<React.SetStateAction<InvoiceErrors>>;
  showRateInput: boolean;
  toolTipText?: string;
  currencyList: {
    value: any;
    label: any;
    name: any;
    icon: JSX.Element | null;
  }[];
  localCurrency: string;
}

const InvoiceCurrency: React.FC<InvoiceCurrencyProps> = ({
  formData,
  selectedCurrencyLabel,
  handleDropDownChange,
  showRateInput,
  setFormData,
  toolTipText,
  currencyList,
  localCurrency,
}) => {
  const { t } = useTranslation("invoices");
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block md:block xl:mt-[1em] lg:mt-[1em] w-full relative z-9">
        <div className="mt-1 flex flex-col justify-end items-end text-right xl:mr-[14.5em] md:mr-[14em] biglg:mr-[18em] bigmd:mr-[15em]">
          <div
            className="xl:mr-[-11.7em] md:mr-[-12em] biglg:mr-[-13.7em] lg:mr-[-11em]"
            ref={dropdownRef}
          >
            <div className="flex gap-1">
              <label
                htmlFor="Currency"
                className="lg:text-[15px] md:text-[14px] font-medium md:mr-[3em] biglg:mr-[1em] xl:mr-[1.1em] cursor-pointer"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("selectCurrency")}
              </label>
            </div>
            <div className="w-full">
              <DropdownComponent
                name="currency"
                options={currencyList}
                value={formData.currency}
                placeholder={selectedCurrencyLabel || "Select Currency"}
                selectedValue={selectedCurrencyLabel}
                onChange={(name, value) => handleDropDownChange(name, value)}
                dropdownClassName="lg:w-[420px]  md:w-[240px] rounded cursor-pointer md:mt-[0.6em]"
                iconClassName="ml-[5em] mt-[0.7em]"
              />
            </div>
          </div>
        </div>
        <div>
          {formData.currency !== localCurrency && showRateInput && (
            <div className="flex gap-4 w-[400px] mt-3">
              <ExchangeRateIcon />
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 w-full">
                <div className="font-medium text-[14px] leading-5 text-gray-600 mb-2">
                  Exchange Rate
                </div>
                <InputComponent
                  type="number"
                  value={
                    formData.exchangeRate !== 0 ? formData.exchangeRate : ""
                  }
                  name="exchangeRate"
                  handleChange={(e) =>
                    setFormData({
                      ...formData,
                      exchangeRate: parseFloat(e.target.value) || 0,
                    })
                  }
                  className="w-full border-none rounded-lg bg-[#ffffff]"
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="mr-[5em] xl:mr-[5.5em] flex flex-col justify-end items-end text-right mt-[-3em]">
          {formData.currency !== "NGN" && showRateInput && (
            <>
              <label
                htmlFor="exchangeRate"
                className="xl:text-[13px] mr-[3.6em] mt-[-2em] biglg:mr-[16em] lg:mr-[15.5em] bigmd:mr-[18.2em] md:mr-[15.5em] md:mt-[4.5em] lg:mt-[4em] md:text-[14px] font-norm cursor-pointer xl:mr-[17.9em]"
                style={{ whiteSpace: "nowrap" }}
              >
                Enter Rate
              </label>
              <div className="xl:mt-[0.3em] biglg:mt-[0.2em] lg:mt-[0.3em] bigmd:mt-[0.4em] md:mt-[0.1em] mr-[-4em] md:mr-[-2.9em] bigmd:mr-[-2em] biglg:mr-[-1.8em] xl:mr-[-1.7em] lg:mr-[-1.8em]">
                <InputComponent
                  type="number"
                  value={
                    formData.exchangeRate !== 0 ? formData.exchangeRate : ""
                  }
                  name="exchangeRate"
                  placeholder="Exchange Rate"
                  handleChange={(e) =>
                    setFormData({
                      ...formData,
                      exchangeRate: parseFloat(e.target.value) || 0,
                    })
                  }
                  className="lg:w-[320px] md:w-[330px] cursor-pointer"
                />
              </div>
            </>
          )}
        </div> */}
      </div>

      {/* Mobile */}
      <div className="md:hidden mt-[1.2em]">
        <div className="w-full">
          <label
            className="text-[14px] font-medium leading-5 text-[#000]"
            htmlFor="currency"
          >
            {t("selectCurrency")}
          </label>
          <DropdownComponent
            name="currency"
            options={currencyList}
            value={formData.currency}
            placeholder={selectedCurrencyLabel || "Select Currency"}
            selectedValue={selectedCurrencyLabel}
            onChange={(name, value) => handleDropDownChange(name, value)}
            dropdownClassName="w-full mt-1 rounded-lg placeholder:text-[16px] placeholder:text-gray-400 border border-gray-300"
            iconClassName="mt-[0.5em]"
          />
        </div>
        <div>
          {formData.currency !== localCurrency && showRateInput && (
            <div className="flex gap-4 w-full mt-3">
              <ExchangeRateIcon />
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 w-full">
                <div className="font-medium text-[14px] leading-5 text-gray-600 mb-2">
                  Exchange Rate
                </div>
                <InputComponent
                  type="number"
                  value={
                    formData.exchangeRate !== 0 ? formData.exchangeRate : ""
                  }
                  name="exchangeRate"
                  handleChange={(e) =>
                    setFormData({
                      ...formData,
                      exchangeRate: parseFloat(e.target.value) || 0,
                    })
                  }
                  className="w-full border-none rounded-lg bg-[#ffffff]"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default InvoiceCurrency;
